import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, IconButton, Tab, Tabs } from "@mui/material";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import PricingGrid from "../../components/PricingGrid";
import SearchBar from "../../components/SearchBar";
import VehicleListings from "../../features/manageVehicles/vehicleListings";
import AddIcon from "@mui/icons-material/Add";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const CustomTabPanel = ({ children, value, index }: TabPanelProps) => (
  <div role="tabpanel" hidden={value !== index}>
    {value === index && children}
  </div>
);

const a11yProps = (index: number) => ({
  id: `tab-${index}`,
  "aria-controls": `tabpanel-${index}`,
});

const tabTypes = ["Car", "Bike", "Bicycle", "Caravan", "Trucks", "Heavy Equipment"];

const ManageDealersDetail = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const showroomInfo = [
    { label: "Showroom Name", value: "Elite Motors" },
    { label: "Location", value: "Pune, Maharashtra" },
    { label: "Opening - Closing Time", value: "09:00 AM - 08:00 PM" },
    { label: "Registered Address", value: "Baner Road, Pune" },
    { label: "Description", value: "Premium used cars showroom" },
    { label: "Language", value: "English" },
    { label: "Registered Date", value: "01 March 2025" },
  ]

  const OwnerInfo = [
    { label: "Owner Name", value: "Madelyn Dias" },
    { label: "Email", value: "madelyndias@gmail.com" },
    { label: "Phone", value: "+91 9876543210" },
  ];

  return (
    <>
      {/* Page Title */}
      <div className="main_title">
        <h1>Dealer Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> –{" "}
          <button onClick={() => navigate("/manage-dealers")}>
            Dealers Management
          </button>{" "}
          – Dealer Detail
        </p>
      </div>

      {/* Tabs */}
      <div className="table_header">
        <Box className="custom_tabs1">
          <Tabs
            value={activeTab}
            onChange={(_, val) => setActiveTab(val)}
            className="custom_tabs_links"
          >
            <Tab label="Profile Information" {...a11yProps(0)} />
            <Tab label="Documents" {...a11yProps(1)} />
            <Tab label="Posted Cars" {...a11yProps(2)} />
          </Tabs>
        </Box>
      </div>

      {/* Profile Info */}
      <CustomTabPanel value={activeTab} index={0}>
        <div className="cards view_page">
          <div className="table_header mb_20">
            <h2>Showroom Information</h2>
            <span className="status_btn dark c_success">Active</span>
          </div>

          {/* Images */}
          <div className="gap_p">
            <div className="w_100">
              <h6>Showroom Image</h6>
              <div className="gap_p">
                <div className="w_25">
                  <div className="vew_img no_radius v2">
                    <figure>
                      <img
                        src="/static/images/placeholder.png"
                        className="view_img"
                        alt=""
                      />
                    </figure>
                  </div>
                </div>
                <div className="w_25">
                  <div className="vew_img no_radius v2">
                    <figure>
                      <img
                        src="/static/images/placeholder.png"
                        className="view_img"
                        alt=""
                      />
                    </figure>
                  </div>
                </div>
                <div className="w_25">
                  <div className="vew_img no_radius v2">
                    <figure>
                      <img
                        src="/static/images/placeholder.png"
                        className="view_img"
                        alt=""
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>

            {showroomInfo.map((item, index) => (
              <div className="w_33" key={index}>
                <h6>{item.label}</h6>
                <p>{item.value}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="cards view_page">
          <div className="table_header mb_20">
            <h2>Owner Information</h2>
          </div>

          {/* Images */}
          <div className="gap_p">
            <div className="w_100">
              <div className="gap_p">
                <div className="w_25">
                  <h6>Dealer Logo</h6>
                  <div className="vew_img no_radius v2">
                    <figure>
                      <img
                        src="/static/images/placeholder.png"
                        className="view_img"
                        alt=""
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>

            {OwnerInfo.map((item, index) => (
              <div className="w_33" key={index}>
                <h6>{item.label}</h6>
                <p>{item.value}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="cards view_page">
          <div className="table_header mb_20">
            <h2>Selected Package</h2>
            {/* <Button className="btn btn_primary sm">Upgrade</Button> */}
          </div>

          <PricingGrid />
        </div>
      </CustomTabPanel>

      {/* Documents */}
      <CustomTabPanel value={activeTab} index={1}>
        <div className="cards view_page">
          <div className="table_header mb_20">
            <h2>Documents</h2>
          </div>


          <div className="gap_p">
            <div className="w_50">
              <h6>Owner ID Proof</h6>
              <div className="doc_preview">
                <AttachFileIcon /> <p>id-proof.jpg</p> <IconButton className='btn_rounded primary'><FileDownloadOutlinedIcon /></IconButton>
              </div>
            </div>

            <div className="w_50">
              <h6>Business Documents</h6>
              <div className="doc_preview">
                <AttachFileIcon /> <p>gst-certificate.jpg</p> <IconButton className='btn_rounded primary'><FileDownloadOutlinedIcon /></IconButton>
              </div>
              <div className="doc_preview">
                <AttachFileIcon /> <p>trade-license.jpg</p> <IconButton className='btn_rounded primary'><FileDownloadOutlinedIcon /></IconButton>
              </div>
            </div>
          </div>
        </div>
      </CustomTabPanel>

      {/* Posted Cars */}
      <CustomTabPanel value={activeTab} index={2}>
        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <Box className="custom_tabs" sx={{ width: "100%" }}>
                <Tabs
                  value={valueTabs}
                  onChange={handleChangeTabs}
                  className="custom_tabs_links mb_0"
                >
                  {tabTypes.map((label, index) => (
                    <Tab key={label} label={label} {...a11yProps(index)} />
                  ))}
                </Tabs>
              </Box>
            </div>
            <div className="right_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search Vehicles..."
              />
              <Button
                className="btn btn_primary"
                onClick={() => navigate("/manage-vehicles/add")}
              >
                <AddIcon /> Add Vehicle
              </Button>
            </div>
          </div>
          {tabTypes.map((type, tabIndex) => (
            <CustomTabPanel key={type} value={valueTabs} index={tabIndex}>
              <VehicleListings type={type} searchTerm={searchTerm} featured={false} />
            </CustomTabPanel>
          ))}
        </div>
      </CustomTabPanel>
    </>
  );
};

export default ManageDealersDetail;
